import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSpeechList } from '../../../services/SpeechToTextService';
import TableComponent, { KeyHeader } from '../../shared/TableComponent';
import { useNavigate } from 'react-router-dom';
import { useTranslate } from 'sbx-crm-menu-ui';
import { TranscriptResponseItem } from '../../../types/SpeechToText';
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from '../../ui/breadcrumb';
import { PenBoxIcon } from 'lucide-react';


const SpeechListComponent = () => {

    const { isPending, data } = useQuery({
        queryKey: ['bot_api'],
        queryFn: getSpeechList,
    });

    const { t: routes } = useTranslate('routes');
    const { t: common } = useTranslate('common');
    const { t: speech } = useTranslate('speech');

    const navigate = useNavigate();

    return (
        <div className="mt-4">
            <Breadcrumb className="my-5 px-2">
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">{routes('home')}</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>{routes('speech-to-text')}</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
            <TableComponent

                items={data?.items ?? []}
                topActions={
                    <div>
                        <button
                            onClick={() => navigate('/speech-to-text/create')}
                            className={`flex btn btn-sm`}>
                            + {common('new')}
                        </button>
                    </div>}
                pagination
                loading={isPending}
                search
                actions={[
                    {
                        label: 'Editar',
                        icon: <PenBoxIcon className="icon-size" />,
                        className: 'btn btn-sm',
                        onClick: (item) => navigate(`/speech-to-text/${item.job_id}`),
                    },
                ]}
                header={[
                    {
                        type: KeyHeader.KEY,
                        label: 'ID',
                        key: 'id',
                    },
                    {
                        type: KeyHeader.KEY,
                        label: common('file'),
                        key: 'name',
                    },
                    {
                        type: KeyHeader.VALUE,
                        label: common('status'),
                        toValue: (item: TranscriptResponseItem) => {
                            return speech(item.state) ?? item.state;
                        },
                    },
                ]}
            />
        </div>
    );
};

export default SpeechListComponent;